// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import 'normalize.css/normalize.css'
import VueAMap from 'vue-amap';
import './assets/css/common.css'
import { Slider, Scrollbar } from 'element-ui';

Vue.prototype.$http=axios;
Vue.config.productionTip = false

Vue.use(Slider);
// Vue.use(Scrollbar);

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '0478b24bdd9a0022a4595f8e11eb52be',
  plugin: ['MarkerClusterer']
})
Vue.config.devtools=true;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js